import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import ProfileDelegatePermissionsList from "./ProfileDelegatePermissionsList";
import { Alert, Button, Form, FormField, TextInput } from "../../ui";

const PermissionsListAny = ProfileDelegatePermissionsList as unknown as React.ComponentType<
  Record<string, unknown>
>;

interface PermissionItem {
  slug?: string;
  front_permission?: string;
  name?: string | { value?: string };
}

interface ProfileDelegateFormProps extends WithTranslation {
  message?: unknown;
  formData: {
    last_name: string;
    first_name: string;
    email: string;
    permissions: string[];
  };
  formError: Record<string, React.ReactNode>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  readonly?: boolean;
  permissions: PermissionItem[];
  permissionsLoaded: boolean;
  delegateUser?: unknown;
  userData?: unknown;
  customerData?: unknown;
}

function ProfileDelegateForm({
  t,
  formData,
  formError,
  onChange,
  onSubmit,
  readonly,
  permissions,
  permissionsLoaded,
}: ProfileDelegateFormProps) {
  const lastNameId = "ProfileDelegateForm-lastName";
  const firstNameId = "ProfileDelegateForm-firstName";
  const emailId = "ProfileDelegateForm-email";

  return (
    <Form action="/" onSubmit={onSubmit} className="ComposedForm ProfileDelegateForm" noValidate>
      <fieldset className="ComposedForm-fieldset">
        <legend className="ComposedForm-legend">{t("profile.delegate.information")}</legend>
        <div className="ComposedForm-fieldsetInner">
          <FormField
            className="ComposedForm-block"
            label={t("profile.delegate.name")}
            htmlFor={lastNameId}
            error={formError.last_name}
          >
            <TextInput
              className="ComposedForm-input ProfileDelegateForm-input"
              name="last_name"
              id={lastNameId}
              maxLength={255}
              value={formData.last_name}
              onChange={onChange}
              readOnly={!!readonly}
            />
          </FormField>
          <FormField
            className="ComposedForm-block"
            label={t("profile.delegate.firstname")}
            htmlFor={firstNameId}
            error={formError.first_name}
          >
            <TextInput
              className="ComposedForm-input ProfileDelegateForm-input"
              name="first_name"
              id={firstNameId}
              maxLength={255}
              value={formData.first_name}
              onChange={onChange}
              readOnly={!!readonly}
            />
          </FormField>
          <FormField
            className="ComposedForm-block"
            label={t("profile.delegate.email")}
            htmlFor={emailId}
            error={formError.email}
          >
            <TextInput
              type="email"
              className="ComposedForm-input ProfileDelegateForm-input"
              name="email"
              id={emailId}
              maxLength={255}
              value={formData.email}
              onChange={onChange}
              readOnly={!!readonly}
            />
          </FormField>
        </div>
      </fieldset>
      <fieldset className="ComposedForm-fieldset">
        <legend className="ComposedForm-legend">{t("profile.delegate.permissions")}</legend>
        <PermissionsListAny
          formData={formData}
          permissions={permissions}
          permissionsLoaded={permissionsLoaded}
          onChange={onChange}
          readonly={readonly}
        />
        {formError["permissions[]"] ? (
          <Alert variant="error" className="ComposedForm-messageLine error">
            {formError["permissions[]"]}
          </Alert>
        ) : null}
      </fieldset>
      <div className="ComposedForm-block isActionLine">
        <Button type="submit" size="lg" className="Button ComposedForm-submit isLarge">
          {t("common.button_register")}
        </Button>
      </div>
    </Form>
  );
}

export default compose(withTranslation())(ProfileDelegateForm);
